import { Box, Paper, styled, Tooltip } from '@material-ui/core';
import { useLinked } from '@type-r/react';
import * as React from 'react';
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList } from 'react-window';
import { colors } from '../common';
import { Flex } from '../flex';
import { RoundCheckbox } from '../forms';
import InfiniteLoader from 'react-window-infinite-loader';
/**
 * Fixed size list which renders only visible elements
 * !!! Make sure to apply passed in *style* parameter !!!
 */
export var TilesList = function (_a) {
    var items = _a.items, noItems = _a.noItems, height = _a.height, maxVisibleItemCount = _a.maxVisibleItemCount, itemSize = _a.itemSize, renderer = _a.renderer, selected = _a.selected, expandedAppBar = _a.expandedAppBar, selectedItem = _a.selectedItem, isItemLoaded = _a.isItemLoaded, loadMoreItems = _a.loadMoreItems, itemCount = _a.itemCount;
    if (maxVisibleItemCount) {
        var visibleItemCount = Math.min(items.length, maxVisibleItemCount);
        var calcHeight = visibleItemCount * itemSize + 20; // size to fit + scrollbar
        height = height ? Math.min(height, calcHeight) : calcHeight;
    }
    var $scrollToItem = useLinked(true);
    return items.length ?
        React.createElement(Flex, { stretch: true },
            React.createElement(AutoSizer, { disableHeight: Boolean(height) }, function (_a) {
                var width = _a.width, _height = _a.height;
                return React.createElement(InfiniteLoader, { isItemLoaded: isItemLoaded, itemCount: itemCount, loadMoreItems: loadMoreItems }, function (_a) {
                    var onItemsRendered = _a.onItemsRendered, ref = _a.ref;
                    return (React.createElement(FixedSizeList, { style: { overflowX: 'auto' }, width: width, height: height || _height, itemCount: itemCount ? itemCount : items.length, itemSize: itemSize, itemData: { items: items, selected: selected }, ref: function (ref) {
                            if (ref && selectedItem && $scrollToItem.value) {
                                ref.scrollToItem(items.findIndex(function (item) { return item === selectedItem; }), 'smart');
                                $scrollToItem.false();
                            }
                        }, onItemsRendered: onItemsRendered }, renderer));
                });
            }))
        :
            React.createElement(LeftTitle, { style: { paddingLeft: '20px' } }, noItems || 'No items to show');
};
export var Tile = function (_a) {
    var _b = _a.$checked, $checked = _b === void 0 ? undefined : _b, _c = _a.large, large = _c === void 0 ? false : _c, style = _a.style, _d = _a.onClick, onClick = _d === void 0 ? undefined : _d, color = _a.color, _e = _a.left, left = _e === void 0 ? undefined : _e, title = _a.title, _f = _a.aboveTitle, aboveTitle = _f === void 0 ? undefined : _f, children = _a.children, _g = _a.extra, extra = _g === void 0 ? undefined : _g, _h = _a.leftTitle, leftTitle = _h === void 0 ? undefined : _h, _j = _a.right, right = _j === void 0 ? undefined : _j, _k = _a.icon, icon = _k === void 0 ? undefined : _k;
    return React.createElement(TilesRow, { onClick: onClick, style: style },
        $checked && React.createElement(RoundCheckbox, { "$checked": $checked, marginRight: -30 }),
        React.createElement(PrimaryTile, { large: large },
            React.createElement(Flex, { alignCenter: true },
                icon ? icon : React.createElement(Box, { minWidth: 50 }),
                React.createElement(ColorBar, { color: color, hasCheckbox: Boolean($checked) })),
            left &&
                React.createElement(Box, { minWidth: 120, mr: 1 },
                    React.createElement(LeftTitle, null, leftTitle),
                    React.createElement(TileField, null, left)),
            React.createElement(Flex, { column: true },
                aboveTitle ?
                    React.createElement(Flex, { row: true }, aboveTitle)
                    : undefined,
                React.createElement(Title, null, title),
                React.createElement(Flex, { row: true }, children)),
            extra ?
                React.createElement(Flex, { row: true, grow: true }, extra)
                : null),
        right &&
            React.createElement(SecondaryTile, null, right));
};
export var SmallTile = styled(function (_a) {
    var color = _a.color, menu = _a.menu, isSelected = _a.isSelected, $selected = _a.$selected, className = _a.className, footer = _a.footer, children = _a.children, onClick = _a.onClick, action = _a.action, right = _a.right;
    return (React.createElement(Paper, { className: className, onClick: onClick || $selected.true },
        React.createElement("div", { className: "color-bar" }),
        React.createElement("div", { className: "body" },
            React.createElement("div", { className: "header" }, children),
            React.createElement("div", { className: "footer" }, footer)),
        right ?
            React.createElement("div", { className: "small-tile-right" }, right)
            : null,
        React.createElement(Flex, { center: true }, action)));
})({
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    height: 56,
    borderRadius: 2,
    borderStyle: "solid",
    borderWidth: 1,
    marginBottom: 8,
    borderColor: function (p) { return ((p.$selected ? p.$selected.value : p.isSelected) ? colors["yellow"] : "white"); },
    backgroundColor: function (p) { return ((p.$selected ? p.$selected.value : p.isSelected) ? "#FFF8E5" : "white"); },
    "& .small-tile-right": {
        alignSelf: 'center',
        padding: 8,
        minWidth: '3em',
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'row'
    },
    "& .body": {
        display: "flex",
        flexDirection: "column",
        padding: 8,
        width: "100%"
    },
    "& .header": {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        fontSize: 14,
        alignItems: "center",
        fontWeight: 600
    },
    "& .footer": {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        alignItems: "center",
        opacity: 0.75,
        fontSize: 12
    },
    "& .color-bar": {
        height: "100%",
        width: 4,
        backgroundColor: function (p) { return colors[p.color]; }
    }
});
export var PrimaryTile = styled(function (_a) {
    var large = _a.large, className = _a.className, children = _a.children;
    return React.createElement(Paper, { className: className + (large ? ' large' : '') }, children);
})({
    display: 'flex',
    flexGrow: 1,
    borderRadius: 0,
    flexDirection: 'row',
    padding: 8,
    '&.large': {
        minWidth: 1100
    }
});
export var Title = styled('div')({
    color: '#000',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: 600,
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
export var LeftTitle = styled('div')({
    marginTop: 4,
    marginBottom: 6,
    opacity: 0.75,
    whiteSpace: "nowrap",
    color: '#101010',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '14px',
});
/**
 * Tile field label
 */
export var TileLabel = styled('span')({
    color: '#728A97',
    marginRight: '1em',
    fontFamily: 'Montserrat',
    fontSize: 10,
    whiteSpace: 'nowrap',
    textTransform: 'uppercase',
});
export var TileField = styled(function (_a) {
    var label = _a.label, children = _a.children, className = _a.className, long = _a.long, compact = _a.compact;
    return React.createElement("div", { className: className + (compact ? ' compact' : '') },
        label &&
            React.createElement(TileLabel, null, label),
        long ?
            React.createElement(Tooltip, { title: children },
                React.createElement("span", { className: "value long" }, children))
            :
                React.createElement("span", { className: "value short" }, children));
})({
    '&.compact': {
        flexDirection: 'column',
        minWidth: 100,
        justifyContent: 'center',
    },
    minWidth: 140,
    display: 'flex',
    fontFamily: 'Montserrat',
    fontSize: 10,
    marginRight: '1em',
    '& .value': {
        marginRight: '1em',
        color: 'black',
        fontWeight: 500,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    '& .short': {
        maxWidth: 95,
    },
    '& .long': {
        maxWidth: 140,
    }
});
export var SecondaryTile = styled(function (_a) {
    var className = _a.className, children = _a.children;
    return React.createElement(Paper, { square: true, className: className }, children);
})({
    backgroundColor: '#FBFCFD',
    alignItems: 'center',
    display: 'flex',
    zIndex: -1
});
export var TilesRow = styled('div')({
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    padding: 2
});
export var ColorBar = function (_a) {
    var color = _a.color, _b = _a.hasCheckbox, hasCheckbox = _b === void 0 ? undefined : _b;
    return React.createElement(Box, { alignSelf: "stretch", width: 2, mr: 1, ml: hasCheckbox ? 1 : 0, bgcolor: color });
};
//# sourceMappingURL=tilesList.js.map